import {format, isFuture, isPast} from 'date-fns'

export function cn (...args) {
  return args.filter(Boolean).join(' ')
}

export function mapEdgesToNodes (data) {
  if (!data.edges) return []
  return data.edges.map(edge => edge.node)
}

export function filterOutDocsWithoutSlugs ({slug}) {
  return (slug || {}).current
}

export function filterOutDocsPublishedInTheFuture ({publishedAt}) {
  return !isFuture(publishedAt)
}

export function filterOutDocsUnpublishedInThePast ({unpublishAt}) {
  return unpublishAt && !isFuture(unpublishAt)
}

export function isValidNeuesProdukt (p) {
  return !p.isAktion && (!p.gueltigBis || isFuture(p.gueltigBis))
}

export function isValidAktion (p) {
  return (
    p.isAktion &&
    (!p.gueltigAb || !isFuture(p.gueltigAb)) &&
    (!p.gueltigBis || !isPast(p.gueltigBis))
  )
}

export function getBlogUrl (publishedAt, slug) {
  return `/blog/${format(publishedAt, 'YYYY/MM')}/${slug.current || slug}/`
}

export function getProductUrl (publishedAt, slug) {
  return `/product/${slug.current || slug}/`
}

export function buildImageObj (source = {asset: {}}) {
  const imageObj = {
    asset: {_ref: source.asset._ref || source.asset._id}
  }

  if (source.crop) imageObj.crop = source.crop
  if (source.hotspot) imageObj.hotspot = source.hotspot

  return imageObj
}

export function toPlainText (blocks) {
  if (!blocks) {
    return ''
  }
  return blocks
    .map(block => {
      if (block._type !== 'block' || !block.children) {
        return ''
      }
      return block.children.map(child => child.text).join('')
    })
    .join('\n\n')
}
